import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { GettingStartedSteps } from '../components/GettingStartedSteps';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
import { AudienceSwitch } from '../components/AudienceSwitch';
import { NovaSection } from '../components/nova/NovaSection';
import { StaticConnectionsBeat } from '../components/StaticConnectionsBeat';
import { TwelveTabProblem } from '../components/TwelveTabProblem';
import { WorkYouCantGetTo } from '../components/WorkYouCantGetTo';
// New Giga home screen. The hero is the "Ask Giga anything, get it done."
// chat-box composer (HowItWorksConnections in hero mode), presented as a
// proper website hero. The Slack "@mention Giga" experience remains its own
// "Works where you work" section further down the page.
// The "AI Co-Pilot for Teams" homepage still lives at /future.
export function Home() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4667" />
      {/* <NovaSection /> Hidden per user request */}
      {/* Integration beat — sits directly beneath the hero (right below the
                                      "Trusted by fast-moving teams" carousel). A calm static
                                      "Shared intelligence for your stack" statement runs a marquee of
                                      app-logo tiles beneath it. The scroll-driven morph still lives on
                                      /chat-transition. */}
      <StaticConnectionsBeat data-id="element-4668" />
      {/* Problem statement — names the "too many tabs / context-switch tax"
              pain, placed right under the connected-stack beat above it. */}
      <TwelveTabProblem data-id="element-4669" />
      {/* Standalone positioning statement — "Giga does the work you can't get
                                      to / shouldn't have to do / keep putting off." */}
      <WorkYouCantGetTo data-id="element-4670" />
      {/* "How it works" / Plug-and-play moved above the Giga for You / Team
                                              audience switch per the intended narrative flow. */}
      <GettingStartedSteps data-id="element-4671" />
      <AudienceSwitch data-id="element-4672" />
      {/* <LivesInSlack /> Hidden from home for now — kept for reuse on another page later */}
      {/* "Built to do the work…" capability grid (four items) leads, then the
                                          "Giga brings its own computer" proof beat — which stays ahead of the
                                          reviews (WallOfLove) below. */}
      <CapabilityGrid data-id="element-4673" />
      <NarrativeSection data-id="element-4674" />
      <ToolComparison data-id="element-4675" />
      <WallOfLove data-id="element-4676" />
      {/* <PricingSection /> Hidden from home for now — still a waitlist. Kept
                                          for reuse; bring back when pricing goes live. */}
      <ClosingCTA data-id="element-4677" />
    </>;
}